import { Client } from '../../client/Client';
import { TAGS_ENDPOINT } from '../../config/Client';

export class TagsController {
  static getAll() {
    return Client.get(`${TAGS_ENDPOINT}`);
  }
}
